const ExcelJS = require('exceljs');

async function exportToExcelConsultaGerAtendimentos(requests) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Requests');

    // Definindo cabeçalhos
    const headers = [
        'UF',
        'ID Requisição',
        'Empresa',
        'NE',
        'Técnico',
        'Empresa Técnico',
        // 'Re/Legal Solicitante',
        'Cód. SAP',
        'Cód. SAP Alternativo',
        'Fornecedor',
        'Tipo Atendimento',
        'Data Abertura',
        'Data Fim(Recebido)',
        'Qtd Solicitada',
        'Qtd Cortada',
        'Qtd a Atender',
        'Qtd Atendida',
        'Qtd Cortada Total',
        'Qtd Pendente',
        'Qtd Coletada',
        'Qtd Aceito Triado',
        'Qtd Rejeitado Triado',
        'Qtde Com CD',
        'Qtde Sem CD',
        'Qtde Sem Defeito',
        'Central',
        'GMO',
        'DRS Original',
        'Status',
        'Ref SAP',
        'Ref SAP Alternativo',
        'Tipo Boleto',
        'Nro Boleto',
        'Observação do Chamado',
        'Site',
        'DRS Atender',
        // 'Telefone',
        // 'Endereço de Entrega',
        // 'Complemento de Entrega',
        'Cidade',
        'Data de SLA',
        'DataCal',
        'DataGestao',
        'DataDeposito',
        // 'Recebido em',
        // 'Data de Atualização',
        'Entregue por',
        "Resp Deposito",
        'Última Observação',
        'Cód Barras Atendidos',
        'Locker',
        'Furto/Vand.',
        'Tipo Planta'
    ];

    worksheet.addRow(headers);

    // Adicionando dados das requests
    requests.forEach(request => {
        // const formattedCreatedAt = moment(request.createdAt).format('DD/MM/YYYY HH:mm');

        const createdAtDate = new Date(request.createdAt);
        let formattedCreatedAt = createdAtDate.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        // Remove a vírgula
        formattedCreatedAt = formattedCreatedAt.replace(', ', ' ');

        const slaDate = new Date(request.slaDate);
        let formattedSlaDate = slaDate.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        // Remove a vírgula
        formattedSlaDate = formattedSlaDate.replace(', ', ' ');
        
        let formattedDataCal
        if (request.dataCal) {
            const slaDataCal = new Date(request.dataCal);
            formattedDataCal = slaDataCal.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
            // Remove a vírgula
            formattedDataCal = formattedDataCal.replace(', ', ' ');
        }

        let formattedDataGestao
        if (request.dataGestao) {
            const slaDataGestao = new Date(request.dataGestao);
            formattedDataGestao = slaDataGestao.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
            // Remove a vírgula
            formattedDataGestao = formattedDataGestao.replace(', ', ' ');
        }

        let formattedDataDeposito
        if (request.dataDeposito) {
            const slaDataDeposito = new Date(request.dataDeposito);
            formattedDataDeposito = slaDataDeposito.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
            // Remove a vírgula
            formattedDataDeposito = formattedDataDeposito.replace(', ', ' ');
        }

        let formattedDataHoraRecebimento;

        if(request.dataHoraRecebimento){
            const dataHoraRecebimento = new Date(request.dataHoraRecebimento);
            formattedDataHoraRecebimento = dataHoraRecebimento.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
            // Remove a vírgula
            formattedDataHoraRecebimento = formattedDataHoraRecebimento.replace(', ', ' ');
        }

        const qtdeColetada = request.reverses?.quantidadeAceita + request.reverses?.quantidadeRejeitada || 0;

        const codSapExport = ['bbn-dwdm-fspo', 'bbn-dwdm-dspo'].includes(request.tipoBoleto)
            ? request.equipamentos?.length
                ? request.equipamentos.map((equipamento) => equipamento.codSap).filter(Boolean).join(', ')
                : request.codSap
            : request.codSap;

        const rowData = [
            request.uf,
            request.idRequest,
            request.empresaSolicitante,
            '',
            request.nomeSolicitante,
            request.empresaTecnico?.socialName || request.empresaSolicitante,
            // request.reLegalSolicitante,
            codSapExport,
            request.codSapAlternativo,
            request.fabricanteEquipamento,
            request.tipoAtendimento,
            formattedCreatedAt,
            formattedDataHoraRecebimento,
            request.quantidadeSolicitada,
            request.quantidadeCortada,
            request.quantidadeAtender,
            request.quantidadeAtendida,
            request.quantidadeCortadaTotal,
            request.quantidadePendente,
            qtdeColetada,
            request.reverses?.quantidadeAceita,
            request.reverses?.quantidadeRejeitada,
            '',
            '',
            '',
            '',
            request.gmo.cidade+" - "+request.gmo.endereco,
            request.drsOriginal?.sigla,
            request.status,
            request.nomeEquipamento,
            request.nomeEquipamentoAlternativo,
            request.tipoBoleto,
            request.idBoleto,
            request.observacao,
            request.site,
            request.drsAtender?.sigla,
            // request.telefone,
            // request.enderecoEntrega,
            // request.enderecoEntregaComplemento,
            request.cidadeEntrega,
            formattedSlaDate,
            formattedDataCal,
            formattedDataGestao,
            formattedDataDeposito,
            // formattedDataHoraRecebimento,
            // request.updatedAt,
            request.nomeEntregador,
            request.respDeposito,
            request.ultimaObs,
            request.codItemsAtendidos?.join(', '),
            request.is_locker === true ? true : '',
            request.isFurtoVandalismo === true ? true : '',
            request.tipoPlanta,
        ];
        worksheet.addRow(rowData);
        // const row = worksheet.addRow(rowData);
        // row.getCell(7).alignment = { wrapText: true, vertical: 'top' };
        // row.getCell(headers.length).alignment = { wrapText: true, vertical: 'top' };
    });

    // Salvar o arquivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'requests.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
}

export default exportToExcelConsultaGerAtendimentos;
